import { reactive, ref, computed, watch } from '@vue/composition-api'
import * as apiQA from '@/api/qa'

/**
 * 書籍検索ウィンドウ
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    search_text: '', // 検索キーワード

    list: [], // 一覧表示用リスト
    allList: [], // 全データリスト
    book_ids: [], // 書籍ID（データバインディング用）

    // 書籍を指定：書籍ID、書籍名のオブジェクトのリスト
    bookList: [],

    selectedBookIds: [], // 選択した書籍ID

    bookIdNameMap: {}, // 選択した書籍IDと名前の対応マップ

    isDataLoaded: false, // データロード完了フラグ
    
    /**
     * データロード発動
     * startLoading=trueになった時にloadData()メソッドを実行する
     */
    startLoading: watch(() => {
      if (props.startLoading) {
        group1.loadData()
      }
    }),

    /**
     * 表示用データをロードする
     */
    loadData: () => {
      
      // 書籍一覧APIをコール
      const params = {}
      params.search_range = 3 // キーワード検索対象範囲：3=QA

      apiQA.listBooksForSearch(params)
        .then(response => {
          if (response) {
            const { data } = response

            const products = data.products ?? [] // 商品＆書籍
            const books = data.books ?? [] // 単体書籍

            // 初期化
            const list = [] // 結果リスト
            group1.bookIdNameMap = {} // 選択した書籍IDと名前の対応マップ

            // 【仕様】
            // 書籍を選んで必要な情報を表示するため、
            // ここでは、パッケージ書籍＆単体書籍で重複する書籍(書籍ID)は除外する
            const flagMap = {}
            for (let i = 0; i < products.length; i++) {
              for (let k = 0; k < products[i].books.length; k++) {
                const book = products[i].books[k]
                const key = 'book_' + book.book_id
                if (flagMap[key] === 1) {
                  // 重複する書籍は除外
                  continue
                }
                list.push(book)
                group1.bookIdNameMap[key] = book.name
                flagMap[key] = 1
              }
            }
            for (let i = 0; i < books.length; i++) {
              const book = books[i]
              const key = 'book_' + book.book_id
              if (flagMap[key] === 1) {
                // 重複する書籍は除外
                continue
              }
              list.push(book)
              group1.bookIdNameMap[key] = book.name
              flagMap[key] = 1
            }

            group1.list = list
            group1.allList = list

            // 書籍ID（データバインディング用）の初期化
            const selectedBookList = context.parent.group1.selectedBookList
            const bookIdsWork = []
            for (let i = 0; i < selectedBookList.length; i++) {
              bookIdsWork.push(selectedBookList[i].id)
            }
            group1.book_ids = bookIdsWork

            // 選択した書籍ID
            group1.selectedBookIds = group1.book_ids
          }
        })
        .finally(() => {
          group1.isDataLoaded = true
        })
    },

    /**
     * キーワード検索
     */
    search: () => {

      if (group1.search_text === '') {
        group1.list = group1.allList
      } else {
        const listWork = []
        for (let i = 0; i < group1.allList.length; i++) {
          const bookName = group1.allList[i].name
          if (bookName.indexOf(group1.search_text) >= 0) {
            listWork.push(group1.allList[i])
          }
        }
        group1.list = listWork
      }
    },

    /**
     * 選択項目が変わった場合
     */
    onSelectedItemsChanged: (bookId) => {

      // group1.book_idsはキーワード検索されたリスト内での選択された書籍IDであり、
      // 全書籍内で選択した書籍でははいので、
      // group1.book_idsとgroup1.selectedBookIdsは同じとは限らない。

      // 状態が変化した書籍IDのチェックボックスがチェックONになったかOFFになったかを調べる
      let isChecked = false
      for (let i = 0; i < group1.book_ids.length; i++) {
        if (bookId === group1.book_ids[i]) {
          // チェックボックスがONだった場合
          isChecked = true
          break
        }
      }

      if (isChecked) {
        // チェックされた場合
        group1.selectedBookIds.push(bookId)
        group1.selectedBookIds.sort()
      } else {
        // チェックが外された場合
        group1.selectedBookIds = group1.selectedBookIds.filter(n => n !== bookId)
      }
    },

    /**
     * 決定ボタンを押した場合
     */
    submit: () => {

      // 選択した書籍名
      const selectedBookNames = []
      // 選択した書籍名(オブジェクトのリスト：保存用JSON構造)
      const newBookList = []
      for (let i = 0; i < group1.selectedBookIds.length; i++) {
        const selectedBookId = group1.selectedBookIds[i]
        const bookName = group1.bookIdNameMap['book_' + selectedBookId]

        selectedBookNames.push(bookName)

        const map = {
          id: selectedBookId,
          name: bookName
        }
        newBookList.push(map)
      }

      context.parent.group1.selectedBookList = newBookList

      context.emit('closeSearchDetailBookList')
    }
    
  })

  return group1
}
